import { ServiceType } from '../../pages/VasHub/ServiceListings/serviceConfig';

export type Filters = { nationality?: string };

export function shouldShowUsdPricingNotice(
  filters: Filters | undefined,
  defaultCountryCode?: string,
  selectedChips?: string[],
): boolean {
  const nationality = filters?.nationality;

  const hasTestTab =
    !selectedChips || selectedChips.length === 0 || selectedChips.includes(ServiceType.TESTS);

  if (!hasTestTab) {
    return false;
  }

  if (nationality) {
    return nationality.toUpperCase() !== 'IN';
  }

  if (defaultCountryCode) {
    return defaultCountryCode.toUpperCase() !== 'IN';
  }

  return true;
}
